import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Constants } from '../lib/const/constants';
import { useLocation, useNavigate } from 'react-router-dom';
import Beneficiary from './Beneficiaries/Beneficiary';
import getCurrencySymbol, { getCountryInfo } from '../lib/currenyUtils';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { encryptPayload } from '../utils/encryption';
import { ArrowRight } from 'lucide-react';

function SendMoney() {
  const navigate = useNavigate();
  const location = useLocation();
  const paramsdata = location.state;
  const preservedAmount = location.state?.preservedAmount;
  var currency = paramsdata?.currency;
  var transferflowamount = paramsdata?.transferflowamount;
  var currencyid = paramsdata?.currencyid;
  var balance = paramsdata?.balance;

  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState('');
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [selectedbeneficiary, setselectedbeneficiary] = useState('');
  const [selectedbeneficiaryCode, setselectedbeneficiaryCode] = useState('');
  const [selectedbeneficiaryBankAccoutNumber, setselectedbeneficiaryBankAccoutNumber] = useState('');
  const [selectedbeneficiaryType, setselectedbeneficiaryType] = useState('');
  const [selectedbeneficiaryId, setselectedbeneficiaryId] = useState('');
  const [selectedbeneficiaryCountry, setselectedbeneficiaryCountry] = useState('');
  const [selectedbeneficiaryBankAccountId, setselectedbeneficiaryBankAccountId] = useState('');
  const [selectedbeneficiaryBeneType, setselectedbeneficiaryBeneType] = useState('');
  const [selectedbeneficiaryBankType, setselectedbeneficiaryBankType] = useState('');
  const [selectedbeneficiaryPaymentType, setselectedbeneficiaryPaymentType] = useState('');

  const Nav_node = paramsdata?.Nav_node;
  const workspaces = JSON.parse(sessionStorage.getItem('login_workspaces'));
  const account_type = workspaces?.[0]?.type;
  const beneficiaryLists = [];

  console.log("SendMoney state:", location.state);

  useEffect(() => {
    getData();
    removeData();
    beneficiaryList();
  }, []);

  const getData = async () => {
    if (transferflowamount != '' && transferflowamount != null) {
      setAmount(transferflowamount);
      sessionStorage.setItem('receive', JSON.stringify(currencyid));
    } else if (preservedAmount) {
      setAmount(preservedAmount); 
    }
  };

  
    const numberWithCommas = (value) => {
    if (value === null || value === undefined || value === '') {
      return '0';
    }

    const valueStr = String(value);
    const [integerPart, decimalPart] = valueStr.split('.');

    const formattedInteger =
      integerPart.length >= 5
        ? integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        : integerPart;

    return decimalPart !== undefined
      ? `${formattedInteger}.${decimalPart}`
      : formattedInteger;
  };

  const numberWithCommasIndian = (value) => {
    if (value === null || value === undefined || value === '') {
      return '0';
    }

    const valueStr = String(value);
    const [integerPartRaw, decimalPart] = valueStr.split('.');

    const isNegative = integerPartRaw.startsWith('-');
    const integerPart = isNegative ? integerPartRaw.slice(1) : integerPartRaw;

    let formattedInteger = integerPart;

    if (integerPart.length >= 5) {
      const lastThree = integerPart.slice(-3);
      const otherDigits = integerPart.slice(0, -3);
      formattedInteger =
        otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + lastThree;
    }

    formattedInteger = isNegative ? `-${formattedInteger}` : formattedInteger;

    return decimalPart !== undefined
      ? `${formattedInteger}.${decimalPart}`
      : formattedInteger;
  };

  const formatAmount = (value, currencyCode) =>
    currencyCode === 'INR' ? numberWithCommasIndian(value) : numberWithCommas(value);





  const countries = JSON.parse(sessionStorage.getItem("countries")) || []
  const countryname = (countryid)=> countries.find((c)=>Number(c.id) === Number(countryid))?.name || '';

  const removeData = async () => {
    sessionStorage.removeItem('send');
    sessionStorage.removeItem('receive');
  };

  const getClearbankBene = async (token, workspaceId) => {
    const encryptedPayload = await encryptPayload({ workspace_id: workspaceId,platform: 'web',
              extraParamValidation: 'trustedfromweb' });
    await axios
      .post(
        Constants.BASE_URL + 'API-FX-191-CLEAR-BANK-LIST-BENEFICIARY',
        encryptedPayload,
        {
          headers: {
            fx_key: Constants.SUBSCRIPTION_KEY,
            Authorization: 'Bearer ' + JSON.parse(token),
          },
        },
      )
      .then((resp) => {
        
        resp.data.data.forEach((element) => {
          beneficiaryLists.push({
            Currency: element.currency,
            id: element.id,
            display_name: element.beneficiaryName,
            bank_account_number: element.banks[0].accountNumber,
            country_flag: Constants.FXMASTER_BASE_URL + 'flags/UK.png',
            avatar: '',
            code: element.banks[0].sortCode,
            bank_code_type: 'sort_code',
            type: 'Sort Code',
            account: element.type,
            country: element.country,
            bank_account_name: '',
            bank_account_id: element.banks[0].id,
            bene_type: element.type,
            bank_type: 'clear_bank',
          });
        });
        
        setBeneficiaries(beneficiaryLists);
        setLoading(false);
        // setBeneficiaries((beneficiaries) => [...beneficiaries, beneficiaryLists]);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const getCCBene = async (token, workspaceId) => {
    try {
      const response = await axios.get(`${Constants.BASE_URL}API-FX-126-ListBeneficiary`, {
        params: {
          workspace_id: workspaceId,
          reference_type: 'money_transfer',
          country_id: currencyid,
        },
        headers: {
          fx_key: Constants.SUBSCRIPTION_KEY,
          Authorization: `Bearer ${JSON.parse(token)}`,
        },
      });

      const countryCodeMapping = {
        105: 'ifsc_code', 234: 'aba_number', 231: 'sort_code', 38: 'branch_code',
        13: 'bsb_number', 2: 'iban_number', 1: 'iban_number', 55: 'iban_number',
        114: 'iban_number', 115: 'iban_number', 129: 'iban_number', 158: 'iban_number',
        177: 'iban_number', 198: 'iban_number', 59: 'iban_number', 95: 'iban_number',
        100: 'iban_number', 193: 'iban_number', 249: 'iban_number', 130: 'iban_number'
      };

      const beneficiaryLists = response.data.data
        .filter((element) => countryCodeMapping[element.meta.bank_country])
        .map((element) => ({
          id: element.id,
          display_name: element.display_name,
          bank_account_number:
            element.meta.bank_account_number != null && element.meta.bank_account_number != ''
              ? element.meta.bank_account_number
              : element.meta.iban,
          country_flag: element.country_flag,
          avatar: element.avatar,
          code:
            element.meta.bic_number ?? element.meta.aba_number ?? 
            element.meta.aba_number ?? element.meta.sort_code ?? 
            element.meta.branch_code ?? element.meta.bsb_number ?? 
            element.meta.bank_code ?? element.meta.ifsc_code ?? element.meta.routing_code_value_1,
          bank_code_type: element.meta.bank_code_type,
          type: element.type,
          country: countryname(element.meta?.selected_bank_country),
          payment_type: element.meta.payment_type,
          country_id: element.meta.bank_country,
          bank_account_name: element.meta.bank_account_name,
          bank_account_id: element.meta?.id || element.id || '',
          bene_type: element.type,
          bank_type: 'currency_cloud',
          address: element.meta.beneficiary_address,
          beneficiary_postcode: element.meta.beneficiary_postcode, 
          meta: element.meta,  
        }));

      setBeneficiaries((beneficiaries) => [...beneficiaries, ...beneficiaryLists]);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const beneficiaryList = async () => {
    setLoading(true);
    const token = sessionStorage.getItem('login_token');
    const workspaceId = sessionStorage.getItem('login_workspaces_id');
    if (currencyid == 231) {
      await getClearbankBene(token, workspaceId);
      await getCCBene(token, workspaceId);
    } else {
      await getCCBene(token, workspaceId);
    }
  };

  const selectedBeneficiary = async (
    display_name, code, bank_account_number, type,
    beneficiaryid, country, address,bank_account_id, country_id, bene_type, bank_type, currency,payment_type
  ) => {
    console.log(display_name, code, bank_account_number, type, beneficiaryid, country,address, bank_account_id,payment_type);
    setselectedbeneficiary(display_name.toUpperCase());
    setselectedbeneficiaryCode(code);
    setselectedbeneficiaryBankAccoutNumber(bank_account_number);
    setselectedbeneficiaryType(type);
    setselectedbeneficiaryId(beneficiaryid);
    setselectedbeneficiaryCountry(country);
    setselectedbeneficiaryBankAccountId(bank_account_id);
    setselectedbeneficiaryBeneType(bene_type);
    setselectedbeneficiaryBankType(bank_type);
    setselectedbeneficiaryPaymentType(payment_type);
  };

  const proceedToPay = async () => {
    if (amount == 0 || amount == '' || amount == null) {
      toast.error('Please enter a valid amount');
    } else {
      balance = balance.split(',');
      balance = balance.join('');
      balance = parseFloat(balance).toFixed(2);
      console.log(balance);
      if (parseFloat(balance) >= parseFloat(amount)) {
        navigate('/PaymentConfirmation', {
          state: {
            name: selectedbeneficiary,
            ifsc: selectedbeneficiaryCode,
            account: selectedbeneficiaryBankAccoutNumber,
            type: selectedbeneficiaryType,
            id: selectedbeneficiaryId,
            bank_account_name: selectedbeneficiary,
            currencyid: paramsdata.currencyid,
            currency: paramsdata.currency,
            balance:balance,
            amount: amount,
            bank_account_id: selectedbeneficiaryBankAccountId,
            country: selectedbeneficiaryCountry,
            bene_type: selectedbeneficiaryBeneType,
            bank_type: selectedbeneficiaryBankType,
            Nav_node: Nav_node,
            payment_type: selectedbeneficiaryPaymentType
          },
        });
      } else {
        toast.error('Insufficient Funds.');
      }
    }
  };

  const isReady = selectedbeneficiary && amount;

  return (
    <div style={styles.page}>
      <ToastContainer />

      <div style={styles.centerCol}>

        <div style={styles.topCard}>

          <div style={styles.currencyRow}>
            {React.isValidElement(getCountryInfo(currency).flag) ? (
              getCountryInfo(currency).flag
            ) : (
              <img
                src={getCountryInfo(currency).flag}
                alt="flag"
                style={styles.flag}
                onError={(e) => (e.target.src = '/flags/default.png')}
              />
            )}
            <span style={styles.currencyCode}>{currency}</span>
            {account_type == 'business' && (
              <span style={styles.currencyBalance}>
                ({getCurrencySymbol(currency)} {formatAmount(String(balance).replace(/,/g, ''), currency)})
              </span>
            )}
          </div>

          <div style={styles.amountInputWrapper}>
            <span style={styles.currencyPrefix}>{getCurrencySymbol(currency)}</span>
            <input
              id="amount"
              type="number"
              min="0"
              value={amount}
              placeholder="Enter Amount"
              style={{
                ...styles.amountInput,
                fontWeight: amount ? 700 : 400,
                color: amount ? '#1D2338' : '#8F959F',
              }}
              onFocus={(e) => { e.target.style.borderColor = '#0B214E'; }}
              onBlur={(e) => {
                e.target.style.borderColor = '#E2E6ED';
                if (amount !== '' && !isNaN(amount)) {
                  setAmount(parseFloat(amount).toFixed(2));
                }
              }}
              onChange={(e) => {
                const val = e.target.value;
                if (val === '') { setAmount(''); return; }
                const validated = val.match(/^\d*\.?\d{0,2}$/);
                if (validated) { setAmount(validated[0]); }
              }}
            />
          </div>

        </div>

        <button
          onClick={proceedToPay}
          disabled={!selectedbeneficiary || !amount}
          style={{
            ...styles.proceedBtn,
            background: isReady ? '#D26521' : '#D1D5DB',
            cursor: isReady ? 'pointer' : 'not-allowed',
          }}
          onMouseEnter={(e) => { if (isReady) e.currentTarget.style.opacity = '0.88'; }}
          onMouseLeave={(e) => { e.currentTarget.style.opacity = '1'; }}
        >
          <span>Proceed</span>
          <ArrowRight className='w-5 h-5 -ml-2.5'/>
        </button>

        <div style={styles.sectionHeader}>
          <h3 style={styles.sectionTitle}>Select Beneficiary</h3>
          <button
            onClick={() =>
              navigate('/BeneficiaryTypes', {
                state: { currency, transferflowamount: amount, currencyid, balance,Nav_node },
              })
            }
            style={styles.addBtn}
            onMouseEnter={(e) => { e.currentTarget.style.opacity = '0.85'; }}
            onMouseLeave={(e) => { e.currentTarget.style.opacity = '1'; }}
          >
            + Add Beneficiary 
          </button>
        </div>

        {loading ? (
          <div style={styles.loadingText}>Loading beneficiaries...</div>
        ) : (
          <Beneficiary
            beneficiaryList={beneficiaries}
            sendDataToParent={selectedBeneficiary}
            currency_type={paramsdata?.currency || ''}
            balance={balance}
            amount={amount}
            currencyid={currencyid}
          />
        )}

      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    padding: '32px 40px 40px',
    boxSizing: 'border-box',

    display: 'flex',
    justifyContent: 'center',

    backgroundColor: '#ffffff',
    backgroundImage: 'linear-gradient(to bottom, #f8fafc 0%, #eff6ff4d 50%, #eef2ff66 100%)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },

  centerCol: {
    width: '100%',
    maxWidth: '720px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  topCard: {
    width: '640px',
    height: '162px',
    background: '#FFFFFF',
    borderRadius: '12px',
    border: '1px solid #F2F2F2',
    boxShadow: '0px 4px 16px -4px rgba(0, 0, 0, 0.06)',
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginBottom: '16px',
    boxSizing: 'border-box',
  },

  currencyRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    height: '32px',
    width: '100%',
  },

  flag: {
    width: 32,
    height: 22,
    objectFit: 'cover',
    borderRadius: 3,
    flexShrink: 0,
  },

  currencyCode: {
    fontFamily: 'Inter, sans-serif',
    fontSize: 15,
    fontWeight: 700,
    color: '#1D2338',
  },

  currencyBalance: {
    fontFamily: 'Inter, sans-serif',
    fontSize: 15,
    fontWeight: 400,
    color: '#1D2338',
  },

  amountInputWrapper: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },

  currencyPrefix: {
    position: 'absolute',
    left: '16px',
    width: 'auto',
    height: '32px',
    fontSize: '15px',
    fontWeight: 500,
    color: '#9CA3AF',
    pointerEvents: 'none',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
  },

  amountInput: {
    width: '100%',
    height: '56px',
    borderRadius: '12px',
    border: '1px solid #E2E6ED',
    paddingTop: '12px',
    paddingRight: '16px',
    paddingBottom: '12px',
    paddingLeft: '36px',
    fontSize: '15px',
    fontWeight: 400,
    color: '#8F959F',
    background: '#FFFFFF',
    outline: 'none',
    boxSizing: 'border-box',
    transition: 'border-color 0.15s',
  },

  proceedBtn: {
  width: '640px',
  height: '56px',

  borderRadius: '12px',
  border: 'none',
  paddingTop: '12px',
  paddingRight: '20px',
  paddingBottom: '12px',
  paddingLeft: '20px',

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '16px',

  background: '#D7D7D7',
  boxShadow: '0px 8px 20px 0px #0000001F',

  fontFamily: 'Inter, sans-serif',
  fontSize: '16px',
  fontWeight: 700,
  color: '#FFFFFF',
  letterSpacing: 0,

  opacity: 1,
  transition: 'opacity 0.15s',
  marginBottom: '28px',
},

  sectionHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 16,
    height: '48px',
    width: '768px',
  },

  sectionTitle: {
  width: '159px',
  height: '48px',
  whiteSpace: 'nowrap',
  fontWeight: 700,
  fontStyle: 'normal',       
  fontSize: '20px',
  lineHeight: '48px',
  letterSpacing: '0px',

  color: '#203358',     

  margin: 0,
  opacity: 1,
},

  addBtn: {
  width: '178px',
  height: '48px',
  borderRadius: '12px',
  paddingTop: '12px',
  paddingRight: '16px',
  paddingBottom: '12px',
  paddingLeft: '16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '12px',
  cursor: 'pointer',
  fontSize: '14px',
  fontWeight: 700,
  letterSpacing: '0.28px',
  color: '#FFFFFF',
  background: '#203358',
  border: 'none',
  opacity: 1,
  transition: 'opacity 0.15s',
},

  loadingText: {
    textAlign: 'center',
    padding: '2rem',
    color: '#64748b',
    fontSize: 14,
    fontFamily: 'Inter, sans-serif',
  },
};

export default SendMoney;